<template>
  <v-card
    class="catalog-issues d-flex flex-column pa-3"
    fluid
    flat
  >
    <div class="secondary--text text--lighten-2 text-subtitle-2">
      errors &amp; warnings:
    </div>
    <v-list
      dense
      class="pa-0 text-body-2"
    >
      <v-list-item-group
        v-model="issues"
        color="primary"
      >
        <v-list-item
          v-for="(issue, i) in issues"
          :key="i"
          dense
        >
          <v-list-item-icon>
            <v-icon
              :color="getIcon(issue[0]).color"
              small
              v-text="getIcon(issue[0]).name"
            />
          </v-list-item-icon>
          <v-list-item-content class="secondary--text text--lighten-4">
            {{ issue[1] }}
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
export default {
	name: 'CatalogIssues',

	props: {
		issues: {
			type: Array,
			required: true,
		},
	},
	data: () => ({}),
	computed: {},
	methods: {
		/**
		 * Returns the icon and color.
		 * Without arg: returns the icon corresponding to the load status
		 * With optional arg issueType: returns the icon for a given issue entry
		 */
		getIcon(issueType) {
			if (issueType === 'error')
				return {
					name: 'mdi-alert-circle',
					color: 'error',
				}
			else if (issueType === 'warning')
				return {
					name: 'mdi-alert-outline',
					color: 'warning',
				}
			else
				return {
					name: 'mdi-help',
					color: 'light-blue lighten-4',
				}
		},
	},
}
</script>

<style lang="scss"></style>
